// extracted by mini-css-extract-plugin
export default {"skeleton":"Y7GQR","wave":"dOawS","circle":"q87m_","text":"XoLQl"};